"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IModelsClient = void 0;
/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
const base_1 = require("./base");
const Constants_1 = require("./Constants");
const operations_1 = require("./operations");
const CheckpointOperations_1 = require("./operations/checkpoint/CheckpointOperations");
const IModelsApiUrlFormatter_1 = require("./operations/IModelsApiUrlFormatter");
/**
 * iModels API client for iModel management workflows. For more information on the API visit the
 * {@link https://developer.bentley.com/apis/imodels/ iModels API documentation page}.
 */
class IModelsClient {
    /**
     * Class constructor.
     * @param {iModelsClientOptions} options client options. If `options` are `undefined` or if some of the properties
     * are `undefined` the client uses defaults. See {@link iModelsClientOptions}.
     */
    constructor(options) {
        const filledIModelsClientOptions = IModelsClient.fillConfiguration(options);
        this._operationsOptions = {
            ...filledIModelsClientOptions,
            urlFormatter: new IModelsApiUrlFormatter_1.IModelsApiUrlFormatter(filledIModelsClientOptions.api.baseUrl)
        };
    }
    /** iModel operations. See {@link iModelOperations}. */
    get iModels() {
        return new operations_1.IModelOperations(this._operationsOptions);
    }
    /** Briefcase operations. See {@link BriefcaseOperations}. */
    get briefcases() {
        return new operations_1.BriefcaseOperations(this._operationsOptions);
    }
    /** Changeset operations. See {@link ChangesetOperations}. */
    get changesets() {
        return new operations_1.ChangesetOperations(this._operationsOptions, this.namedVersions, this.checkpoints);
    }
    /** Named version operations. See {@link NamedVersionOperations}. */
    get namedVersions() {
        return new operations_1.NamedVersionOperations(this._operationsOptions);
    }
    /** Checkpoint operations. See {@link CheckpointOperations}. */
    get checkpoints() {
        return new CheckpointOperations_1.CheckpointOperations(this._operationsOptions);
    }
    /**
     * Creates a required configuration instance from user provided options and applying default ones for not specified
     * options. See {@link iModelsClientOptions}.
     * @param {iModelsClientOptions} options user-passed client options.
     * @returns {RecursiveRequired<iModelsClientOptions>} required iModels client configuration options.
     */
    static fillConfiguration(options) {
        var _a, _b, _c, _d, _e;
        return {
            restClient: (_a = options === null || options === void 0 ? void 0 : options.restClient) !== null && _a !== void 0 ? _a : new base_1.AxiosRestClient(),
            api: {
                baseUrl: (_c = (_b = options === null || options === void 0 ? void 0 : options.api) === null || _b === void 0 ? void 0 : _b.baseUrl) !== null && _c !== void 0 ? _c : Constants_1.Constants.api.baseUrl,
                version: (_e = (_d = options === null || options === void 0 ? void 0 : options.api) === null || _d === void 0 ? void 0 : _d.version) !== null && _e !== void 0 ? _e : Constants_1.Constants.api.version
            }
        };
    }
}
exports.IModelsClient = IModelsClient;
//# sourceMappingURL=IModelsClient.js.map